import styled from "styled-components"
import { ErrorSpan } from "../../form"

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-inline: clamp(1.5rem, -0.45rem + 9.75vw, 11.25rem);
  padding-block-start: clamp(1rem, 0rem + 5vw, 6rem);
  padding-block-end: clamp(3rem, 2.4rem + 3vw, 6rem);
  background-color: ${(props) => props.theme.colors.boxBackground};
`

const StyledSpan = styled.span`
  font-size: clamp(1rem, 0.9rem + 0.5vw, 1.5rem);
  font-weight: 700;
`

const BottomErrorSpan = styled(ErrorSpan)`
  margin-block-start: 2rem;
  text-align: center;
`
export { BottomErrorSpan, Container, StyledSpan }
